// // 测试
// const VUE_APP_WS_URL = 'ws://121.196.205.21:8080/websocket';
// const VUE_APP_BASEURL = 'http://121.196.205.21:8080';

// 正式
// const VUE_APP_WS_URL = 'wss://www.saxtrader.net/websocket';
// const VUE_APP_BASEURL = 'https://www.saxtrader.net';
// const VUE_APP_WS_URL = 'wss://www.galaxytrader.cloud/websocket';
// const VUE_APP_BASEURL = 'https://www.galaxytrader.cloud';
const VUE_APP_WS_URL = 'wss://api.aura-crypto.com/websocket';
//const VUE_APP_WS_URL = 'ws://127.0.0.1:9089/websocket';
// const VUE_APP_WS_URL = 'ws://http://192.168.3.9:8080/websocket';
const VUE_APP_BASEURL = 'https://api.aura-crypto.com';
//const VUE_APP_BASEURL = 'http://127.0.0.1:9089';
// const VUE_APP_BASEURL = 'http://192.168.3.9:8080';
// 测试
// const VUE_APP_WS_URL = 'ws://103.234.54.7:8080/websocket';//测试
// const VUE_APP_BASEURL = 'http://103.234.54.7:8080';//测试
// 本地
// const VUE_APP_BASEURL = 'https://u798377y57.zicp.fun';

// 仅允许钱包登录（总开关）。
// 注意：不能依赖 window.ethereum 是否注入来决定，因为 Trust Wallet iOS 26.20+
// 等环境注入失败时仍可通过 WalletConnect 兜底连接，所以路由拦截只看本开关。
const JUST_WALLET = false

/** 当前环境是否存在 EIP-1193 Provider（MetaMask / Trust / 内置钱包等） */
export function isWeb3Injected() {
  return typeof window !== 'undefined' && typeof window.ethereum !== 'undefined'
}

/**
 * 是否启用「仅钱包」流程。
 *
 * 语义：
 *   - true  → 全站只允许钱包登录，禁用 /pass/login、/pass/register、/pass/reset
 *   - false → 钱包登录与账号登录并存，/empty 上会同时显示 Connect Wallet 与
 *             Login with Account 两个入口
 *
 * 不论返回 true 还是 false，未登录用户都会被路由守卫拦截到 /empty。
 */
export function useWalletOnlyFlow() {
  return JUST_WALLET
}

export { VUE_APP_WS_URL, VUE_APP_BASEURL, JUST_WALLET };
